import React, { useContext } from 'react';
import loadable from '@loadable/component';
import DialogForm from '../DialogForm';
import { Context } from '../../context/AppContext';
import FullScreenLoader from '../FullScreenLoader';
import { MODALS } from '../../constants';
import WelcomeSuccessModal from '../WelcomeSuccessModal';

const Form = loadable(() => import('./AddABusiness'), {
  fallback: <FullScreenLoader />,
});

const AddABusiness = () => {
  const modalName = MODALS.ADD_A_BUSINESS;

  const {
    modal: { modals, hideModal },
    user: { userContactDetails },
  } = useContext(Context);

  const { show } = modals[modalName] || {};

  return (
    <>
      <DialogForm
        show={show}
        name={modalName}
        clickOutside
        maxWidth="915px"
        onDialogFormClose={() => {
          hideModal(MODALS.TRADING_HOURS);
          hideModal(modalName);
        }}
      >
        <Form data={{ ...userContactDetails }} />
      </DialogForm>
      <WelcomeSuccessModal />
    </>
  );
};

export default AddABusiness;
